// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"33a1eb92","142":"b28fc144","258":"0e54ad92","339":"7b01a372","463":"0a24b2b5","539":"9a7ad8bc","573":"5f479369","740":"242fd322","811":"13e966fe","863":"05eec5eb","880":"a0ea327f"}[chunkId] + ".chunk.js";
};